import SlimSelect from "slim-select";
import contries from "./contries.json";
import "../Styles/main.scss";

const countriesSelect = {
  placeholder: "You can enter the name of the country",
  searchPlaceholder: "You can enter the name of the country"
};

const whereFindSelect = {
  placeholder: "Choose one of the options",
  searchPlaceholder: "Choose one of the options"
};

const selects = document.querySelectorAll(".ui-field select");

function moveCursorToEnd(el) {
  if (typeof el.selectionStart == "number") {
    el.selectionStart = el.selectionEnd = el.value.length;
  } else if (typeof el.createTextRange != "undefined") {
    el.focus();
    var range = el.createTextRange();
    range.collapse(false);
    range.select();
  }
}

const setSearchFromSelected = list => {
  const select = list.select.element.parentElement;
  if (!select) return;

  const input = select.querySelector(".ss-search input");
  const selected = list.data.data.find(item => item.value === list.selected());
  if (selected && input) {
    input.value = selected.text || "";
    moveCursorToEnd(input);
  }
};

[...selects].forEach(element => {
  element.selectedIndex = -1;
  const list = new SlimSelect({
    select: element,
    hideSelectedOption: false,
    searchingText: "Text",

    searchFilter: (opt, search) => {
      const select = list.select.element.parentElement;
      const content = select.querySelector(".ss-content");
      if (content) content.style.height = "";

      return opt.text.toLowerCase().startsWith(search.toLowerCase());
    },

    beforeClose: () => {
      document.body.style.overflow = "";
    },

    afterOpen: () => {
      const select = list.select.element.parentElement;
      const content = select.querySelector(".ss-content");
      if (content) {
        content.style.height = "";
        content.addEventListener("click", () => list.close());
        setSearchFromSelected(list);
      }
    },

    beforeOpen: () => {
      setSearchFromSelected(list);
      if (window.innerWidth <= 450) {
        document.body.style.overflow = "hidden";
      }
    },

    ...(element.id === "Input_Country" ? countriesSelect : whereFindSelect)
  });

  if (element.id === "Input_Country") {
    list.setData(contries.map(v => ({ text: v, value: v })));
    element.selectedIndex = -1;
  }
});

[...document.querySelectorAll(".ss-search input")].forEach(input => {
  input.addEventListener("click", e => e.stopPropagation());
  input.setAttribute("autocomplete", "nope");
  input.setAttribute("type", "input");
});